module.exports = __webpack_public_path__ + "static/media/dog.ba2bbe5b.png";